import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { Button } from '@/Components/ui/button';
import { EmployerLayout } from '../Pages/JobPostPricing/EmployerLayout';

/** Shown instead of a page the person's role doesn't include. They stay signed in
 *  and keep the menu, so they are never stranded. */
export const NoAccess = () => {
  const navigate = useNavigate();
  return (
    <EmployerLayout>
      <div className="flex flex-col items-center justify-center py-24 text-center">
        <ShieldAlert className="mb-3 h-8 w-8 text-muted-foreground" aria-hidden="true" />
        <h1 className="text-lg font-semibold text-foreground">You don't have access to this page</h1>
        <p className="mt-1 max-w-sm text-sm text-muted-foreground">
          Your role doesn't include it. Ask your company admin if you need access.
        </p>
        <Button type="button" size="sm" className="mt-4" onClick={() => navigate('/hirewithus/overview')}>
          Go to Overview
        </Button>
      </div>
    </EmployerLayout>
  );
};

/** The first load of a team member's access failed, so nothing can be shown yet. */
export const AccessCheckFailed = ({ onRetry }) => (
  <div className="flex min-h-screen flex-col items-center justify-center p-6 text-center">
    <h1 className="text-lg font-semibold text-foreground">We couldn't check your access</h1>
    <p className="mt-1 text-sm text-muted-foreground">Check your connection and try again.</p>
    <Button type="button" size="sm" className="mt-4" onClick={onRetry}>
      Try again
    </Button>
  </div>
);

export default NoAccess;
